import React from 'react';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';

const Container = styled(FlexContainer)`
  flex-wrap: wrap;
  ${props => props.theme.desktopLayout`
      box-sizing: border-box
   `}

  &&& > * {
    width: 33.33%;
  }
`;

const MetricTiles = ({children}) => {
  return <Container>{children}</Container>;
};

export default MetricTiles;
